import { useEffect } from "react";
import { NextRouter } from "next/router";
import { DbUser } from "canbook-data/user/models";
import { getCookie } from "cookies-next";

type Props = {
  router: NextRouter;
  user: DbUser | undefined;
  userLoading: boolean;
  queryParams: Record<string, unknown>;
  redirectUrl: unknown;
  setCheckingAuth: (value: boolean) => void;
};

export const useAuthRedirect = ({
  router,
  user,
  userLoading,
  queryParams,
  redirectUrl,
  setCheckingAuth,
}: Props) => {
  useEffect(() => {
    if (!userLoading) {
      const loginUser = getCookie("Authorization") as string;

      if (user && loginUser) {
        if (user.user_name && user.user_name !== "") {
          if (queryParams && redirectUrl) {
            router.replace(redirectUrl as string);
          } else {
            router.replace("/");
          }
          return;
        }
      }

      setCheckingAuth(false);
    }
  }, [userLoading, user, queryParams, redirectUrl, router, setCheckingAuth]);
};
